import { Component } from '@angular/core';
import { ArticleSeoComponent } from '../article-seo';
import { ArticleTemplateComponent } from '../article-template/article-template.component';

@Component({
  selector: 'app-article-04',
  imports: [ArticleTemplateComponent],
  templateUrl: './article-04.component.html',
  styleUrls: []
})
export class Article04Component extends ArticleSeoComponent {
  protected readonly seo = {
    pageTitle: 'Quais são os tipos de leilão de imóveis e como escolher o melhor para você | Casato Brasil',
    description: 'Compare leilão judicial, extrajudicial e venda direta da Caixa para entender qual modalidade faz mais sentido para o seu perfil e objetivo de compra.'
  };
}
